var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsd = function SvgUsd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.365 1.533C13.798.567 11.998 0 10.03 0v1.533h5.334Z",
    fill: "#ED4C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.031 3.067h7.2c-.566-.567-1.2-1.1-1.866-1.534H10.03v1.534Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.031 4.6h8.434a11.097 11.097 0 0 0-1.2-1.533H10.03V4.6Z",
    fill: "#ED4C5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.031 6.133h9.234c-.234-.533-.5-1.066-.8-1.533H10.03v1.533Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.031 7.667h9.734a11.77 11.77 0 0 0-.5-1.534H10.03v1.534Z",
    fill: "#ED4C5C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.031 9.233h9.967c-.033-.533-.133-1.033-.233-1.533H10.03v1.533",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.998 9.233H10.03V10h-10c0 .267 0 .5.034.767h19.933c.033-.267.033-.5.033-.767s0-.533-.033-.767",
    fill: "#ED4C5C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M.298 12.3h19.467c.133-.5.2-1 .233-1.533H.064c.034.5.1 1.033.234 1.533Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M.798 13.833h18.467c.2-.5.366-1 .5-1.533H.298c.133.533.3 1.033.5 1.533Z",
    fill: "#ED4C5C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1.598 15.367h16.866c.3-.5.567-1 .8-1.534H.799c.233.534.5 1.034.8 1.534",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M2.798 16.9h14.467c.433-.467.866-1 1.2-1.533H1.598c.333.566.767 1.066 1.2 1.533Z",
    fill: "#ED4C5C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.665 18.433h10.733c.7-.433 1.3-.966 1.867-1.533H2.798c.567.6 1.2 1.1 1.867 1.533Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.031 20c1.967 0 3.8-.567 5.367-1.567H4.665c1.566 1 3.4 1.567 5.366 1.567Z",
    fill: "#ED4C5C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.698 1.533c-.7.434-1.333.967-1.9 1.534-.467.466-.867 1-1.2 1.533-.3.5-.6 1-.8 1.533-.2.5-.367 1-.5 1.534-.133.5-.2 1-.233 1.533-.034.267-.034.533-.034.8h10V0C8.065 0 6.265.567 4.698 1.533Z",
    fill: "#428BC1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m7.698.333.167.5h.5l-.4.334.133.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM9.031 2.333l.167.5h.5l-.4.334.133.5-.4-.3-.4.3.134-.5-.4-.334h.5l.166-.5ZM6.365 2.333l.166.5h.5l-.4.334.134.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM7.698 4.333l.167.5h.5l-.4.334.133.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM5.031 4.333l.167.5h.5l-.4.334.133.5-.4-.3-.4.3.134-.5-.4-.334h.5l.166-.5ZM2.365 4.333l.166.5h.5l-.4.334.134.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM9.031 6.333l.167.5h.5l-.4.334.133.5-.4-.3-.4.3.134-.5-.4-.334h.5l.166-.5ZM6.365 6.333l.166.5h.5l-.4.334.134.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM3.698 6.333l.167.5h.5l-.4.334.133.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM7.698 8.333l.167.5h.5l-.4.334.133.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM5.031 8.333l.167.5h.5l-.4.334.133.5-.4-.3-.4.3.134-.5-.4-.334h.5l.166-.5ZM2.365 8.333l.166.5h.5l-.4.334.134.5-.4-.3-.4.3.133-.5-.4-.334h.5l.167-.5ZM3.298 3.667l.4-.3.4.3-.167-.5.4-.334h-.5l-.133-.5-.167.5h-.466l.4.3-.167.534M.631 7.667l.4-.3.4.3-.166-.5.4-.334h-.467l-.167-.5-.166.5H.53c0 .034-.033.067-.033.1l.267.2-.134.534",
    fill: "#fff"
  })));
};
export default SvgUsd;